import React, { useCallback, useEffect, useState } from "react";
import { useAuth } from "../context/AuthContextProvider";
import { useQuery } from "@tanstack/react-query";
import { Link } from "react-router-dom";
import toast from "react-hot-toast";
import { getProfileInfo, toggleState } from "../services/settings";
import Wave from "../assets/images/Waving.png";
import { IoPersonCircle } from "react-icons/io5";

const Toggle = () => {
  const [drop, setDrop] = useState(false);
  const [previewImage, setPreviewImage] = useState(null);
  const { setGlobalProfile, globalProfile, user, logout } = useAuth();
  const ProfileDropDown = () => {
    setDrop(!drop);
  };

  const handleProfileInfo = async () => {
    try {
      const res = await getProfileInfo();
      return res;
    } catch (error) {
      if (error.response) {
        toast.error(error.response.data.message);
      }
    }
  };

  const query = useQuery({
    queryKey: ["profileInfo"],
    queryFn: handleProfileInfo,
  });

  const profileImage = useCallback(() => {
    if (query.data?.data?.base64File) {
      // Convert binary data to a data URL
      const dataUrl = `data:image/jpeg;base64,${query.data?.data?.base64File}`;
      setPreviewImage(dataUrl);
    }
  }, [query.data?.data?.base64File]);

  useEffect(() => {
    if (query.data) {
      profileImage();
    }
  }, [query.data, profileImage]);

  const updateLocalStorageObject = (key, updatedProperties) => {
    // Retrieve the object from local storage
    const storedObject = JSON.parse(localStorage.getItem(key) ?? "{}");

    // Update the object with the new properties
    const updatedObject = { ...storedObject, ...updatedProperties };

    // Save the updated object back to local storage
    localStorage.setItem(key, JSON.stringify(updatedObject));
  };

  const getCurrentProfile = () => {
    if (globalProfile === "TEST") {
      updateLocalStorageObject("user", {
        profile: "PRODUCTION",
      });
      setGlobalProfile("PRODUCTION");
      return "PRODUCTION";
    } else {
      updateLocalStorageObject("user", {
        profile: "TEST",
      });
      setGlobalProfile("TEST");
      return "TEST";
    }
  };

  const toggleProfile = async () => {
    try {
      const profile = getCurrentProfile();
      setGlobalProfile(profile);
      const res = await toggleState(profile);
      toast.success(res.message);
      window.location.reload()
    } catch (error) {
      if (error.response) {
        toast.error(error.response.data.message);
      }
    }
  };
  return (
    <div className="flex flex-col sm:flex-row items-start md:items-center md:pl-4 gap-4">
      <div className="flex justify-start md:justify-end">
        {user.migrated && (
          <label className="switch">
            <input
              type="checkbox"
              onChange={toggleProfile}
              checked={globalProfile === "PRODUCTION"}
              disabled={user.migrated === false}
            />
            <span className="slider round"></span>
          </label>
        )}
      </div>

      <div>
        <p
          className={`${globalProfile === "TEST" ? "text-test" : "text-live"
            } text-[12px] font-extrabold`}
        >
          {globalProfile === "TEST" ? "TEST" : "LIVE"}
        </p>
      </div>
      <div
        className="relative flex items-center gap-3 text-[16px] font-semibold"
        onClick={ProfileDropDown}
      >
        {query.data?.data?.base64File === null ? (
          <>
            <div className="cursor-pointer text-[35px]">
              <IoPersonCircle />
            </div>
            <div>
              <p className="text-[12px] font-bold">
                {query.data.data.firstName} {query.data.data.lastName}
              </p>
              <p className="text-[10px] font-semibold text-gray-400">
                {user.role}
              </p>
            </div>
          </>
        ) : (
          <>
            <img
              onClick={ProfileDropDown}
              src={previewImage}
              alt="profile-pic"
              className="w-[45px] h-[43px] cursor-pointer rounded-full"
            />
            <div>
              <p className="text-[12px] font-bold">
                {query.data?.data?.firstName} {query.data?.data?.lastName}
              </p>
              <p className="text-[10px] font-semibold text-gray-400">
                {user.role}
              </p>
            </div>
          </>
        )}
        {drop ? (
          <div className="shadow-md absolute top-16  xl:right-0 bg-white z-10 w-[20rem] p-5 h-[10rem] rounded-md">
            <div className="flex gap-1 pb-5 text-center justify-center">
              Welcome {user.firstName}!
              <img className="w-6" alt="" src={Wave} />
            </div>
            <div className="flex flex-col gap-5 text-primary">
              <Link
                to="/settings/profile"
                className="border-b border-primary pb-3"
              >
                View Profile
              </Link>
              <p onClick={logout} className="cursor-pointer">
                Logout
              </p>
            </div>
          </div>
        ) : (
          ""
        )}
      </div>
      <style>
        {`
.switch {
  position: relative;
  display: inline-block;
  width: 33.33px;
  height: 17px;
}

.switch input { 
  opacity: 0;
  width: 0;
  height: 0;
}

.slider {
  position: absolute;
  cursor: pointer;
  top: 2.3px;
  left: 0;
  right: 0;
  bottom: 0;
  background-color: #FF0000;
  -webkit-transition: .4s;
  transition: .4s;
}

.slider:before {
  position: absolute;
  content: "";
  height: 10px;
  width: 10px;
  left: 2px;
  top:1.75px;
  
  background-color: #FFF;
  -webkit-transition: .4s;
  transition: .4s;
}

input:checked + .slider {
  background-color: #00A241;
}

input:focus + .slider {
  box-shadow: 0 0 1px #2196F3;
}

input:checked + .slider:before {
  -webkit-transform: translateX(18px);
  -ms-transform: translateX(18px);
  transform: translateX(18px);
}

/* Rounded sliders */
.slider.round {
  border-radius: 34px;
}

.slider.round:before {
  border-radius: 50%;
}

.table-row {
  padding: 10px; /* Adjust the padding value as needed */
}`}
      </style>
    </div>
  );
};

export default Toggle;
